var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$props.includeHeader
    ? _c("div", { staticClass: "hello screen-spacing" }, [
        _c("label", { staticClass: "me-2 h4", attrs: { for: "dropdown" } }, [
          _vm._v(" Select Location "),
          _vm.$props.optional
            ? _c("span", { staticStyle: { color: "grey" } }, [
                _vm._v(" (Optional)"),
              ])
            : _vm._e(),
          _vm._v(": "),
        ]),
        _c(
          "select",
          {
            key: _vm.tracker,
            staticClass: "form-select",
            attrs: { id: "dropdown" },
            on: {
              change: function ($event) {
                return _vm.updateBar($event)
              },
            },
          },
          _vm._l(_vm.barList, function (item, index1) {
            return _c(
              "option",
              {
                key: index1,
                staticClass: "card mx-3",
                domProps: { value: item._id },
              },
              [_vm._v(_vm._s(item.name))]
            )
          }),
          0
        ),
      ])
    : _c("div", [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.barValue,
                expression: "barValue",
              },
            ],
            key: _vm.tracker,
            staticClass: "form-select",
            attrs: { id: "dropdown" },
            on: {
              change: [
                function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.barValue = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
                function ($event) {
                  return _vm.updateBar($event)
                },
              ],
            },
          },
          _vm._l(_vm.barList, function (item, index2) {
            return _c(
              "option",
              {
                key: index2,
                staticClass: "card mx-3",
                domProps: { value: item._id },
              },
              [_vm._v(_vm._s(item.name))]
            )
          }),
          0
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }